module.exports = "../images/fishing-trip@2x.jpg?v=9061163";